/* eslint-disable i18next/no-literal-string */
import React from 'react';

import BismillahSVG from '../../../../public/bismillah.svg';

const Bismillah = () => <BismillahSVG />;

export default Bismillah;
